export default function AttorneyBios() {
  const attorneys = [
    {
      name: 'Hong-min Jun',
      title: 'Founding Attorney',
      bio: 'Hong-min Jun founded the Law Office with a mission to provide exceptional legal representation to immigrant communities and small business owners. With over 22 years of experience in personal injury law, she has recovered millions in compensation for injured clients. Fluent in English and Korean, Hong-min understands the unique challenges foreign-born individuals face when navigating the legal system.',
      education: ['J.D., Indiana University McKinney School of Law', 'LL.M., Indiana University Maurer School of Law', 'M.A. in Law, KyungHee University'],
      specialties: ['Personal Injury Litigation', 'Immigration Law', 'Workers\' Compensation'],
      languages: ['English', 'Korean']
    },
    {
      name: 'Enrique Flores',
      title: 'Co-Counselor',
      bio: 'Enrique Flores brings a decade of trial experience to the firm. As a first-generation immigrant himself, Enrique is passionate about fighting for the rights of injured workers and accident victims. His aggressive litigation style and compassionate approach have earned him recognition as a rising star in Indiana personal injury law.',
      education: ['J.D., Indiana University McKinney School of Law'],
      specialties: ['Car Accident Cases', 'Wrongful Death', 'Medical Malpractice'],
      languages: ['English', 'Spanish']
    }
  ];

  return (
    <section id="attorneys" className="py-16 bg-lavender-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="mb-12 max-w-4xl">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Our Team</p>
          <h2 className="text-6xl md:text-7xl font-light text-gray-900 leading-tight mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
            Meet Our<br />
            <span className="italic font-normal">Legal Team</span>
          </h2>
          <p className="text-base text-gray-600 leading-relaxed border-l-2 border-gray-900 pl-6" style={{ fontFamily: "'Crimson Pro', serif" }}>
            Our dedicated legal team combines decades of experience with a deep understanding of immigrant communities. We're committed to fighting for your rights and securing the compensation you deserve.
          </p>
        </div>

        {/* Attorneys list */}
        <div className="space-y-10">
          {attorneys.map((attorney, index) => (
            <article key={index} className="border-t border-gray-200 pt-12">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                {/* Left column - Name and title */}
                <div className="lg:col-span-4">
                  <h3 className="text-4xl font-light text-gray-900 mb-2 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {attorney.name}
                  </h3>
                  <p className="text-sm tracking-wider uppercase text-gray-500 mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {attorney.title}
                  </p>
                  
                  {/* Languages */}
                  <div className="mb-8">
                    <p className="text-xs tracking-wider uppercase text-gray-400 mb-3">Languages</p>
                    <div className="flex flex-wrap gap-2">
                      {attorney.languages.map((lang, idx) => (
                        <span key={idx} className="text-xs tracking-wider uppercase text-gray-700 border border-gray-300 px-3 py-1">
                          {lang}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right column - Bio and details */}
                <div className="lg:col-span-8">
                  <p className="text-base text-gray-700 leading-relaxed mb-8" style={{ fontFamily: "'Crimson Pro', serif" }}>
                    {attorney.bio}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Education */}
                    <div>
                      <p className="text-xs tracking-wider uppercase text-gray-400 mb-4">Education</p>
                      <ul className="space-y-2">
                        {attorney.education.map((edu, idx) => (
                          <li key={idx} className="text-sm text-gray-700 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                            {edu}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    {/* Specialties */}
                    <div>
                      <p className="text-xs tracking-wider uppercase text-gray-400 mb-4">Specialties</p>
                      <ul className="space-y-2">
                        {attorney.specialties.map((specialty, idx) => (
                          <li key={idx} className="text-sm text-gray-700 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                            {specialty}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
